const SET_SMART_IS_VISIBLE = 'SET_SMART_IS_VISIBLE';

export { SET_SMART_IS_VISIBLE };



// WEBPACK FOOTER //
// ./src/containers/Inputs/SMART/constants.js